import React, { useId } from 'react'
import PropTypes from 'prop-types'

const TrashIcon = React.forwardRef(function TrashIcon(props, ref) {
  const { color, size, ...otherProps } = props

  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={color}
      {...otherProps}
    >
      <path d="M22 3H16C16 1.35 14.65 0 13 0H11C9.35 0 8 1.35 8 3H2C1.45 3 1 3.45 1 4C1 4.55 1.45 5 2 5H3V19C3 21.76 5.24 24 8 24H16C18.76 24 21 21.76 21 19V5H22C22.55 5 23 4.55 23 4C23 3.45 22.55 3 22 3ZM11 2H13C13.55 2 14 2.45 14 3H10C10 2.45 10.45 2 11 2ZM19 19C19 20.65 17.65 22 16 22H8C6.35 22 5 20.65 5 19V5H19V19Z"></path>
      <path d="M8 8C7.45 8 7 8.45 7 9V18C7 18.55 7.45 19 8 19 8.55 19 9 18.55 9 18V9C9 8.45 8.55 8 8 8ZM12 8C11.45 8 11 8.45 11 9V18C11 18.55 11.45 19 12 19 12.55 19 13 18.55 13 18V9C13 8.45 12.55 8 12 8ZM15 18C15 18.55 15.45 19 16 19 16.55 19 17 18.55 17 18V9C17 8.45 16.55 8 16 8 15.45 8 15 8.45 15 9V18Z"></path>
    </svg>
  )
})

TrashIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
}

TrashIcon.defaultProps = {
  color: 'currentColor',
  size: '24'
}

export default TrashIcon
